import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TZ2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TZ2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V19H22V4H2Z"
        fill="#3195F9"
      />
      <mask
        id="mask0_1813_935"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_935)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19L22 4H2Z"
          fill="#73BE4A"
        />
        <path
          d="M0.471785 20.1598L1.16575 21.1994L2.20542 20.5055L24.8685 5.37829L25.9082 4.68433L25.2142 3.64466L23.8263 1.56532L23.1323 0.525645L22.0927 1.21961L-0.570426 16.3468L-1.6101 17.0407L-0.916137 18.0804L0.471785 20.1598Z"
          fill="#272727"
          stroke="#FFD018"
          strokeWidth="2.5"
        />
      </g>
    </svg>
  );
};

export default TZ2424Icon;
